export type BoardAudience = 'internal' | 'external';

/**
 * MKS-419 — the board query key. Today's three-element key while the merged
 * view is off; the merged board (parent + subprojects) caches under a FOURTH
 * element so the two never share an entry. Every prefix invalidation of
 * ['board', projectId, audience] still refreshes both.
 */
export function boardQueryKey(
  projectId: string,
  audience: BoardAudience,
  includeSubprojects?: boolean,
) {
  return includeSubprojects
    ? (['board', projectId, audience, 'subprojects'] as const)
    : (['board', projectId, audience] as const);
}
